import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { DAppCardCompact } from './DAppCard';
import { top20Dapps } from '../data/dapps';

export const Top20Section = () => {
  const { t } = useLanguage();

  return (
    <section id="top20" className="relative py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-testid="top20-headline">
            {t('top20.headline')}
          </h2>
          <p className="text-lg text-slate-300 max-w-3xl mx-auto">
            {t('top20.subtext')}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {top20Dapps.map((dapp) => (
            <DAppCardCompact key={dapp.id} dapp={dapp} />
          ))}
        </div>
      </div>
    </section>
  );
};
